export default [
  {
    path: 'umum',
    name: 'setting general',
    component: () => import('@/views/app/settings/page-setting-general.vue'),
    meta: { title: 'Pengaturan Umum' },
  },
  {
    path: 'template-share-product',
    name: 'setting template share product',
    component: () => import('@/views/app/settings/page-template-share-product.vue'),
    meta: { title: 'Pengaturan Share Produk' },
  },
]
